import script from "./BookingStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingStep.vue?vue&type=script&setup=true&lang=ts"

import "./BookingStep.vue?vue&type=style&index=0&id=ec3d93a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec3d93a6"]])

export default __exports__